import API from '../../../../API/api';
import {getCsrfTokenQueryParam} from "../../../../utilities/csrf_token_provider";

const onRemoveDiscount = async ({ id }) => {
    const res = await API.DELETE({
        apiPath: `/cart/discount/${id}/?${getCsrfTokenQueryParam()}`,
        data: '',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
    });

    return res;
};

export default onRemoveDiscount;